export default __webpack_public_path__ + "static/media/head1.dd33f9db.png";